import { GenericSelectFilter } from '@app/core/list-view/base-filters/GenericSelectFilter';
import { createFilter } from '@app/core/list-view/types';
import { Station } from '@app/core/types/stations';
import { UploadDto, UploadDtoStatusEnum } from '@app/modules/social-export/social-export.types';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

/**
 * Builds local toolbar filters for social-export uploaded videos (station + status).
 * Station options come from the in-memory stations list.
 */
export function createSocialUploadedFiltersConfig(stations: readonly Station[]) {
  return [
    createFilter({
      name: 'stationId',
      label: defineMessage({
        id: 'socialExport.uploaded.columnStation',
        defaultMessage: 'Estación',
      }),
      parser: parseAsString,
      isPermanent: true,
      component: GenericSelectFilter,
      componentProps: {
        options: stations.map((station) => ({
          value: station.id,
          label: station.name,
        })),
        sx: {
          minWidth: '18ch',
        },
      },
      filterFn: (item, value) => {
        const upload = item as UploadDto;
        if (!value) {
          return true;
        }
        return upload.stationId === value;
      },
    }),
    createFilter({
      name: 'status',
      label: defineMessage({
        id: 'socialExport.uploaded.columnStatus',
        defaultMessage: 'Estado',
      }),
      parser: parseAsString,
      isPermanent: true,
      component: GenericSelectFilter,
      componentProps: {
        options: [
          {
            value: UploadDtoStatusEnum.COMPLETED,
            label: UploadDtoStatusEnum.COMPLETED,
          },
          {
            value: UploadDtoStatusEnum.IN_PROGRESS,
            label: UploadDtoStatusEnum.IN_PROGRESS,
          },
          {
            value: UploadDtoStatusEnum.SCHEDULED,
            label: UploadDtoStatusEnum.SCHEDULED,
          },
          {
            value: UploadDtoStatusEnum.WAITING,
            label: UploadDtoStatusEnum.WAITING,
          },
          {
            value: UploadDtoStatusEnum.WAITING_CHILDREN,
            label: UploadDtoStatusEnum.WAITING_CHILDREN,
          },
          {
            value: UploadDtoStatusEnum.FAILED,
            label: UploadDtoStatusEnum.FAILED,
          },
          {
            value: UploadDtoStatusEnum.CANCELLED,
            label: UploadDtoStatusEnum.CANCELLED,
          },
        ],
        sx: {
          minWidth: '16ch',
        },
      },
      filterFn: (item, value) => {
        const upload = item as UploadDto;
        if (!value) {
          return true;
        }
        return upload.status === value;
      },
    }),
  ];
}
